import React, {useEffect, useState} from 'react'
import Banner from "../Components/Shared/Layout/Banner";
import withLanguage from "../HOC/withLanguage";
import IntroBlock from "../Components/Shared/Layout/IntroBlock";
import {LayoutContent, LayoutLeft, LayoutRight} from "../Components/Shared/Layout/LayoutContent";
import {AccordionBody, AccordionContainer, AccordionTitle} from "../Components/Shared/Layout/InstitutionAccordion";

const BursaTransport = ({language}) => {

    return (
        <>
            <Banner img="/bursa/bursaBanner.jpg" title={language.mainTitle}/>
            <IntroBlock>{language.intro}</IntroBlock>

            <div className="m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
                <p className="text-lg text-justify">{language.p1}</p>
                <p className="text-lg py-3 text-justify">{language.p2}</p>
                <p className="text-lg text-justify">{language.p3}</p>
            </div>

            <div className="flex lg:flex-row flex-col max-h-full text-white roboto-light">
                <div className="lg:w-1/2 w-full">
                    <img src='/bursa/quote.jpg' alt="image-element" className="h-full w-full object-cover object-top"/>
                </div>
                <div className="lg:w-1/2 w-full bg-[#db3222] flex flex-col items-center justify-center p-5">
                    <h3 className="lg:text-2xl text-xl font-bold lg:max-w-[60%] max-w-full">{language.quote}</h3>
                </div>
            </div>

            <section className="m-5 text-lg xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem] flex flex-col gap-3">
                {/* Deadline */}
                <p className="text-red-600 italic font-semibold my-1">
                    {language["bursa_deadline"]}
                </p>

                {/* Intro */}
                <p className="text-[15px] leading-7">{language["bursa_intro"]}</p>

                {/* Two cards */}
                <div className="grid grid-cols-2 max-md:grid-cols-1 gap-6 text-2xl my-4">
                    <div className="rounded-xl shadow-md bg-white p-9 text-center font-medium text-gray-800">
                        {language["bursa_card1"]}
                    </div>
                    <div className="rounded-xl shadow-md bg-white p-9 text-center font-medium text-gray-800">
                        {language["bursa_card2"]}
                    </div>
                </div>

                {/* Transport section */}
                <div className="my-3">
                    <h3 className="text-gray-900 font-bold uppercase">
                        {language["transport_title"]}
                    </h3>
                    <p className="text-[15px] leading-7 mt-2">{language["transport_text"]}</p>
                </div>

                {/* Footer */}
                <p className="text-[15px] leading-7 my-4">{language["bursa_footer"]}</p>

                {/* Buttons */}
                <div className="flex gap-4">
                    <button className="bg-red-600 text-white font-semibold px-6 py-2 rounded-md hover:bg-red-700">
                        {language["btn_bursa"]}
                    </button>
                    <button className="bg-red-600 text-white font-semibold px-6 py-2 rounded-md hover:bg-red-700">
                        {language["btn_transport"]}
                    </button>
                </div>
            </section>


        </>
    )
}

export default withLanguage(BursaTransport, 'BursaTransport')